export { default as TabView } from './tab-view';
export { SceneMap } from 'react-native-tab-view';
